var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Script = function () {
    function Script() {
        var _this = this;

        var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        classCallCheck(this, Script);

        this.attributes = attributes;
        this.element = document.createElement("script");
        Object.keys(this.attributes).forEach(function (key) {
            _this.element[key] = _this.attributes[key].toString();
        });
    }

    createClass(Script, [{
        key: "build",
        value: function build() {}
    }, {
        key: "execute",
        value: function execute() {
            document.head.appendChild(this.element);
        }
    }]);
    return Script;
}();

var LevelEnum = Object.freeze({
    "Functional": 0,
    "Preferences": 1,
    "Analytics": 2,
    "Targeting": 3
});

/**
 * A source of scripts, cookies, localStorage, sessionStorage or other method of identifiable user data.
 */

var Source = function Source(config) {
    classCallCheck(this, Source);

    var defaultConfig = {
        name: "",
        description: "",
        level: LevelEnum.Functional,
        cookies: [],
        localStorage: [],
        sessionStorage: [],
        scripts: [],
        shouldExecute: true
    };

    this.config = _extends({}, defaultConfig, config);
};

var PolyfilledCustomEvent = function PolyfilledCustomEvent(typeArg, customEventInit) {
    classCallCheck(this, PolyfilledCustomEvent);

    if (typeof window.CustomEvent === "function") {
        return new window.CustomEvent(typeArg, customEventInit);
    }

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    return CustomEvent(typeArg, customEventInit);
};

function inArray(array, find) {
    return array.indexOf(find) != -1;
}

function removeFromArray(array, item) {
    var i = array.indexOf(item);
    if (i !== -1) {
        array.splice(i, 1);
    }
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var js_cookie = createCommonjsModule(function (module, exports) {
(function (factory) {
		var registeredInModuleLoader = false;
		if (typeof undefined === 'function' && undefined.amd) {
			undefined(factory);
			registeredInModuleLoader = true;
		}
		{
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	})(function () {
		function extend() {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[i];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}

		function init(converter) {
			function api(key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}

				// Write

				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);

					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}

					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}

					if (!converter.write) {
						value = encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}

					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);

					var stringifiedAttributes = '';

					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return document.cookie = key + '=' + value + stringifiedAttributes;
				}

				// Read

				if (!key) {
					result = {};
				}

				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;

				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');

					if (!this.json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}

					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ? converter.read(cookie, name) : converter(cookie, name) || cookie.replace(rdecode, decodeURIComponent);

						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}

						if (key === name) {
							result = cookie;
							break;
						}

						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}

				return result;
			}

			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};

			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};

			api.withConverter = init;

			return api;
		}

		return init(function () {});
	});
});

var GdprConditionals = function () {
    function GdprConditionals() {
        var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        classCallCheck(this, GdprConditionals);

        var defaultSettings = {
            cookieExpires: 365,
            dispatchEventsOnDOMContentLoaded: true
        };

        this.settings = _extends({}, defaultSettings, settings);

        this.name = "GDRP Conditionals";
        this.id = "gdpr_conditionals";
        this.eventSource = window;
        this.consentedLevelsCookie = "GDPR_CONDITIONALS_CONSENTED_LEVELS";
        this.consentedLevels = [0];
        this.registry = [];
        this.eventQueue = [];

        this.cookieExpires = this.settings.cookieExpires;

        this.populateConsentedLevels();

        if (this.settings.dispatchEventsOnDOMContentLoaded) {
            this.dispatchEventsOnDOMContentLoaded();
        }

        var initializationEventLabel = this.id + "_initialized";
        this.fireEvent(initializationEventLabel, { relayToGtm: true });
    }

    /**
     * Check if the cookie was already set
     * @param name the Cookie we wish to check exists, by default it checks for the {@link this.consentedLevelsCookie GDPR Conditionals consented levels cookie}
     * @returns {boolean}
     */


    createClass(GdprConditionals, [{
        key: "cookieWasSet",
        value: function cookieWasSet() {
            var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.consentedLevelsCookie;

            return !!js_cookie.get(name);
        }

        /**
         * Set the GDPR Conditionals consented levels cookie
         */

    }, {
        key: "setCookie",
        value: function setCookie() {
            js_cookie.set(this.consentedLevelsCookie, this.consentedLevels, { expires: this.settings.cookieExpires });
        }

        /**
         * Get the levels the user consented to
         * @returns {Array|[number]}
         */

    }, {
        key: "getConsentedLevels",
        value: function getConsentedLevels() {
            return this.consentedLevels;
        }

        /**
         * Give consent to a specified level and update the cookies
         * @param {Number} level A level that matches any of the levels in {@link LevelEnum}.
         */

    }, {
        key: "giveConsentToLevel",
        value: function giveConsentToLevel(level) {
            if (!this.isConsentedLevel(level)) {
                this.consentedLevels.push(level);
                this.setCookie();

                var consentLevelEventLabel = this.id + "_consent_level_" + level;
                this.fireEvent(consentLevelEventLabel, { relayToGtm: true });

                this.parseAllSources();
                return this;
            }
        }

        /**
         * Withdraw consent to a specified level and update the cookies
         * @param {Number} level A level that matches any of the levels in {@link LevelEnum}.
         */

    }, {
        key: "withdrawConsentToLevel",
        value: function withdrawConsentToLevel(level) {
            var _this = this;

            if (this.isConsentedLevel(level)) {
                if (level === 0) {
                    return false;
                }

                removeFromArray(this.consentedLevels, level);

                this.setCookie();

                var withdrawConsentLevelEventLabel = this.id + "_withdraw_consent_level_" + level;
                this.fireEvent(withdrawConsentLevelEventLabel, { relayToGtm: true });

                this.registry.forEach(function (source) {
                    if (source.config.level === level) {
                        _this.cleanUp(source);
                    }
                });
            }
        }

        /**
         * Populate the consent levels array from cookies
         */

    }, {
        key: "populateConsentedLevels",
        value: function populateConsentedLevels() {
            var _this2 = this;

            var consentedLevels = js_cookie.getJSON(this.consentedLevelsCookie);
            if (consentedLevels) {
                this.consentedLevels = consentedLevels;
                this.consentedLevels.forEach(function (level) {
                    var consentLevelEventLabel = _this2.id + "_consent_level_" + level;
                    _this2.fireEvent(consentLevelEventLabel, { relayToGtm: true });
                });
            }
        }

        /**
         * Check whether the user provided consent for the provided level
         * @param {Number} level
         * @returns {Boolean}
         */

    }, {
        key: "isConsentedLevel",
        value: function isConsentedLevel(level) {
            return inArray(this.consentedLevels, level);
        }

        /**
         * Register a new source
         * @param {Source} source
         */

    }, {
        key: "register",
        value: function register(source) {
            if (source instanceof Source) {
                this.registry.push(source);

                var registerEventLabel = this.id + "_register";
                this.fireEvent(registerEventLabel, { detail: source });

                if (this.isConsentedLevel(source.config.level)) {
                    this.execute(source);
                }
            } else {
                throw TypeError("Source should be an instance of GdprConditionals.Source");
            }
        }

        /**
         * Loop over all registered sources and execute them if it matches the consent level and
         * if it hasn't already run.
         */

    }, {
        key: "parseAllSources",
        value: function parseAllSources() {
            var _this3 = this;

            this.registry.forEach(function (source) {
                _this3.execute(source);
            });
        }

        /**
         * Execute a source's scripts if it's level is consented to and shouldExecute is true (it should only run once).
         * @param {Source} source
         */

    }, {
        key: "execute",
        value: function execute(source) {
            if (source instanceof Source) {
                if (this.isConsentedLevel(source.config.level) && source.config.shouldExecute) {
                    source.config.scripts.forEach(function (script) {
                        if (script instanceof Script) {
                            script.build();
                            script.execute();
                        }
                    });

                    source.config.shouldExecute = false;

                    var executeEventLabel = this.id + "_execute";
                    this.fireEvent(executeEventLabel, { detail: source });
                }
            } else if (source !== undefined) {
                throw TypeError("Source should be an instance of GdprConditionals.Source");
            }
        }

        /**
         * Clean up the cookies, localStorage entries, sessionStorage and DOM based for the passed source.
         * @param {Source} source
         */

    }, {
        key: "cleanUp",
        value: function cleanUp(source) {
            // This just makes the DOM look a bit nicer, objects, handlers, etc. will still be loaded / available
            // Does not take externally injected scripts in to account
            source.config.scripts.forEach(function (script) {
                if (script.element) {
                    script.element.remove();
                }
            });

            var cookies = source.config.cookies;
            cookies.forEach(function (cookie) {
                js_cookie.remove(cookie);
            });

            var localStorage = source.config.localStorage;
            localStorage.forEach(function (key) {
                window.localStorage.removeItem(key);
            });

            var sessionStorage = source.config.sessionStorage;
            sessionStorage.forEach(function (key) {
                window.sessionStorage.removeItem(key);
            });

            source.config.shouldExecute = true;
        }

        /**
         * Fire events optionally sending them to third-party systems.
         * @param {String} label
         * @param {Object} options
         */

    }, {
        key: "fireEvent",
        value: function fireEvent(label, options) {
            var defaultOptions = {
                detail: null,
                relayToGtm: false
            };

            options = _extends(defaultOptions, options);

            var customEvent = new PolyfilledCustomEvent(label, { detail: options.detail });
            this.eventSource.dispatchEvent(customEvent);

            if (options.relayToGtm) {
                this.fireEventGtm(label);
            }

            this.eventQueue.push(customEvent);
        }

        /**
         * Fire Google Tag Manager (GTM) Events
         * Used to trigger other script and actions from GTM.
         * {@link https://developers.google.com/tag-manager/devguide#events GTM event related docs}
         * @param {String} label The label for the event
         */

    }, {
        key: "fireEventGtm",
        value: function fireEventGtm(label) {
            if (window.dataLayer && window.dataLayer.push && typeof window.dataLayer.push === "function") {
                window.dataLayer.push({ "event": label });
            }
        }

        /**
         * Fire events again when the DOM Content Loaded event was fired, to trigger event handlers further on.
         */

    }, {
        key: "dispatchEventsOnDOMContentLoaded",
        value: function dispatchEventsOnDOMContentLoaded() {
            var _this4 = this;

            if (window) {
                window.addEventListener('DOMContentLoaded', function () {
                    _this4.handleEventQueue();
                });
            }
        }

        /**
         * Loop over all events in the event queue and dispatch them.
         */

    }, {
        key: "handleEventQueue",
        value: function handleEventQueue() {
            var _this5 = this;

            this.eventQueue.forEach(function (event) {
                _this5.eventSource.dispatchEvent(event);
            });
            this.eventQueue = [];
        }
    }]);
    return GdprConditionals;
}();

var ScriptSrc = function (_Script) {
    inherits(ScriptSrc, _Script);

    function ScriptSrc(src, attributes) {
        classCallCheck(this, ScriptSrc);

        var _this = possibleConstructorReturn(this, (ScriptSrc.__proto__ || Object.getPrototypeOf(ScriptSrc)).call(this, attributes));

        _this.src = src;
        return _this;
    }

    createClass(ScriptSrc, [{
        key: "build",
        value: function build() {
            this.element.src = this.src;
        }
    }]);
    return ScriptSrc;
}(Script);

var ScriptFn = function (_Script) {
    inherits(ScriptFn, _Script);

    function ScriptFn(fn, attributes) {
        classCallCheck(this, ScriptFn);

        var _this = possibleConstructorReturn(this, (ScriptFn.__proto__ || Object.getPrototypeOf(ScriptFn)).call(this, attributes));

        _this.fn = fn;
        return _this;
    }

    createClass(ScriptFn, [{
        key: "getFunctionBody",
        value: function getFunctionBody() {
            var entire = this.fn.toString();
            var body = entire.slice(entire.indexOf("{") + 1, entire.lastIndexOf("}")).trim();
            return body;
        }
    }, {
        key: "build",
        value: function build() {
            this.element.textContent = this.getFunctionBody();
        }
    }]);
    return ScriptFn;
}(Script);

export { GdprConditionals as init, Source, LevelEnum as Level, ScriptSrc, ScriptFn };
